// src/components/sign-in/sign-in.component.jsx
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom'; // ✅ Use withRouter instead of useHistory
import { 
  auth, 
  signInWithGoogle, 
  signInWithEmailAndPassword 
} from '../../firebase/firebase.utils';
import './sign-in.styles.scss';

const SignIn = ({ history }) => {  // ✅ Get history from props
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setLoading(false);
      history.push('/');
    } catch (err) {
      console.error('Signin error:', err.code, err.message);
      setError(err.message);
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
      setLoading(false);
      history.push('/');
    } catch (err) {
      console.error('Google signin error:', err.code, err.message);
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="sign-in">
      <h2>Sign In</h2>
      <p>Sign in to your account</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
        </div>
        
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>
        
        {error && <p className="error-message">{error}</p>}
        
        <button type="submit" disabled={loading} className="sign-in-btn">
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        
        <button 
          type="button" 
          onClick={handleGoogleSignIn} 
          className="google-btn"
          disabled={loading}
        >
          <span>🔵</span> Sign in with Google
        </button>
      </form>
    </div>
  );
};

export default withRouter(SignIn);  // ✅ Wrap with withRouter